import { CardInfo } from 'ocean/types/cards';
import { AnyAction } from 'redux';
import { Card } from 'river/types';

export const updateCard = (card: CardInfo): AnyAction => ({
  type: 'User/UPDATE_CARD',
  payload: card,
});
